"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { ListingBusinessBgTypeColor, ListingBusinessRingTypeColor } from "@/components/modules/listings/mappers";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { SearchTypes } from "@/constants/filters";
import { cn } from "@/lib/utils";

/**
 * A colored dot keyed by the listing business type (same palette as the
 * minimized dialog pill). Reveals the business-type label on hover unless
 * `showTooltip` is false.
 */
export function BusinessTypeDot(t0) {
  const $ = _c(17);
  const {
    businessType,
    showTooltip: t1,
    className
  } = t0;
  const showTooltip = t1 === undefined ? true : t1;
  const tListing = useTranslations("modules.listings.listing");
  if (!businessType) {
    return null;
  }
  const type = businessType as unknown as SearchTypes;
  let t2;
  if ($[0] !== businessType || $[1] !== tListing) {
    t2 = tListing(businessType, {
      count: 1
    });
    $[0] = businessType;
    $[1] = tListing;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const label = t2;
  const t3 = ListingBusinessBgTypeColor[type] || "bg-zinc-500";
  const t4 = ListingBusinessRingTypeColor[type] || "ring-zinc-500";
  let t5;
  if ($[3] !== className || $[4] !== t3 || $[5] !== t4) {
    t5 = cn("inline-block w-2.5 h-2.5 rounded-full shrink-0 cursor-default ring-2 ring-offset-1 ring-offset-white", t3, t4, className);
    $[3] = className;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label || $[8] !== t5) {
    t6 = <span aria-label={label} className={t5} />;
    $[7] = label;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const dot = t6;
  if (!showTooltip) {
    return dot;
  }
  let t7;
  if ($[10] !== dot) {
    t7 = <TooltipTrigger asChild={true} data-sentry-element="TooltipTrigger" data-sentry-source-file="BusinessTypeDot.tsx">{dot}</TooltipTrigger>;
    $[10] = dot;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== label) {
    t8 = <TooltipContent className="capitalize" data-sentry-element="TooltipContent" data-sentry-source-file="BusinessTypeDot.tsx">{label}</TooltipContent>;
    $[12] = label;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <TooltipProvider delayDuration={100} data-sentry-element="TooltipProvider" data-sentry-component="BusinessTypeDot" data-sentry-source-file="BusinessTypeDot.tsx"><Tooltip data-sentry-element="Tooltip" data-sentry-source-file="BusinessTypeDot.tsx">{t7}{t8}</Tooltip></TooltipProvider>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}